<script setup lang="ts">
import { INote } from '@/models/note'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'
import Filters from '../filters'
import moment from 'moment'

const properties = defineProps<{
  note: INote
  deletingNote: boolean
}>()
const emit = defineEmits<{
  (e: 'delete-note', noteId: number): void
}>()

const keepLocalTime: boolean = import.meta.env.VITE_KEEP_LOCAL_TIME ?? false
const userStore = useUserStore()
const isCurrentUsersNote = computed(() => {
  return userStore?.adminUserID === properties.note?.createdBy?.id
})
</script>

<template>
  <div class="w-100 mt-2">
    <div
      class="d-flex flex-column"
      :class="{
        'align-end': isCurrentUsersNote,
      }"
    >
      <div
        class="text-sm-caption"
        style="font-weight: 100; font-size: 11px !important"
      >
        <VMenu v-if="isCurrentUsersNote && !note.deletedAt">
          <template #activator="{ props }">
            <VIcon
              title="more"
              v-bind="props"
              size="24"
              class="ml-2 delete-msg-icon"
              icon="tabler-dots"
            />
          </template>
          <VCard>
            <VList>
              <VListItem
                class="text-sm-button cursor-pointer"
                @click="emit('delete-note', note.id)"
              >
                <VListItemTitle>
                  Delete
                  <VIcon
                    v-if="isCurrentUsersNote && !deletingNote"
                    class="ml-2 delete-msg-icon"
                    icon="tabler-trash"
                    size="20"
                    @click.stop="emit('delete-note', note.id)"
                  />
                  <VProgressCircular
                    v-else-if="isCurrentUsersNote && deletingNote"
                    size="20"
                    intermediate
                  />
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCard>
        </VMenu>
      </div>
      <div>
        <VAlert
          :border="isCurrentUsersNote ? false : 'start'"
          :border-color="isCurrentUsersNote ? 'main-primary' : 'tonal'"
          class="text-sm-caption v-chip--label ml-auto h-auto"
          :color="isCurrentUsersNote ? 'main-primary' : 'tonal'"
          style="border-radius: 8px !important"
        >
          {{ note.note }}
        </VAlert>
      </div>
      <div
        class="text-sm-caption"
        style="font-weight: 100; font-size: 11px !important"
      >
        {{ isCurrentUsersNote ? 'YOU' : note.createdBy.email }} {{ ' - ' }}
        <span style="font-weight: 600">{{
          Filters.date.RelativeTime(
            moment.parseZone(note.createdAt).local(keepLocalTime).format(),
          )
        }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.delete-msg-icon {
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #1f4da5;
    transform: scale(1.05);
  }
}
</style>
